<app-template [hasContentFrame]="true" [isContentColorWhite]="false">
  <iframe [src]="iframeUrl"></iframe>
</app-template>
